import { p as proxyCustomElement, H, f as forceUpdate, h } from './p-BJEvNVLM.js';
import { n as nextTick, s as slotMutationService, b as bem } from './p-g1JgJ7wn.js';
import { t as transformTagName, r as resolveAppearance } from './p-CkrRd9Ud.js';
import { F as FormField } from './p-P_M9P1K3.js';
import { g as getAriaRequired, a as getAriaDescribedBy, b as getAriaInvalid } from './p-BLj-uRqX.js';
import { d as defineCustomElement$3 } from './p-ODoCtssu.js';
import { d as defineCustomElement$2 } from './p-BMLmP8GU.js';

const cosmosCheckboxGroupCss = ".cosmos-form-field{display:flex;flex-direction:column}.cosmos-form-field__info-container{display:inline-block;margin-bottom:8px}.cosmos-form-field__info-container:not(.cosmos-form-field__info-container--has-label,.cosmos-form-field__info-container--has-help-text,.cosmos-form-field__info-container--has-required-optional-label){display:none}.cosmos-form-field__label-text,.cosmos-form-field__help-text,.cosmos-form-field__required-optional-label,.cosmos-form-field__validation-message{display:inline}.cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-checkbox-group-label-color);--cosmos-text-font-family:var(--cosmos-checkbox-group-label-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-group-label-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-group-label-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-group-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-group-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-group-label-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-group-label-text-transform)}.cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-checkbox-group-help-text-color);--cosmos-text-font-family:var(--cosmos-checkbox-group-help-text-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-group-help-text-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-group-help-text-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-group-help-text-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-group-help-text-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-group-help-text-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-group-help-text-text-transform)}.cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-checkbox-group-required-optional-label-color);--cosmos-text-font-family:var(--cosmos-checkbox-group-required-optional-label-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-group-required-optional-label-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-group-required-optional-label-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-group-required-optional-label-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-group-required-optional-label-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-group-required-optional-label-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-group-required-optional-label-text-transform);display:inline-block;margin-inline-start:4px;white-space:nowrap}.cosmos-form-field__validation-message{display:flex;gap:4px;margin-top:8px}.cosmos-form-field__validation-message-text{--cosmos-text-font-family:var(--cosmos-checkbox-group-validation-message-font-family);--cosmos-text-font-size:var(--cosmos-checkbox-group-validation-message-font-size);--cosmos-text-font-style:var(--cosmos-checkbox-group-validation-message-font-style);--cosmos-text-font-weight:var(--cosmos-checkbox-group-validation-message-font-weight);--cosmos-text-letter-spacing:var(--cosmos-checkbox-group-validation-message-letter-spacing);--cosmos-text-line-height:var(--cosmos-checkbox-group-validation-message-line-height);--cosmos-text-text-transform:var(--cosmos-checkbox-group-validation-message-text-transform)}.cosmos-form-field__validation-message-icon{--cosmos-icon-color:var(--cosmos-checkbox-group-invalid-color, #E06600);--cosmos-icon-size:calc(16rem / var(--cosmos-base-font-size, 16));flex-shrink:0;padding:1.5px 0}.cosmos-form-field--invalid .cosmos-form-field__label-text,.cosmos-form-field--invalid .cosmos-form-field__validation-message{--cosmos-text-color:var(--cosmos-checkbox-group-label-color)}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-checkbox-group-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-checkbox-group-help-text-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-dark .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-checkbox-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__label-text{--cosmos-text-color:var(--cosmos-checkbox-group-label-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__help-text{--cosmos-text-color:var(--cosmos-checkbox-group-help-text-color, rgba(255, 255, 255, 0.45))}.cosmos-form-field--disabled.cosmos-form-field--appearance-light .cosmos-form-field__required-optional-label{--cosmos-text-color:var(--cosmos-checkbox-group-required-optional-label-color, rgba(0, 15, 30, 0.45))}.cosmos-checkbox-group__fieldset{border:0;margin:0;padding:0}.cosmos-checkbox-group__list{display:flex;flex-direction:column;gap:12px}";

const generateClassNames = bem('cosmos-checkbox-group');
const checkboxTag = transformTagName('cosmos-checkbox');
const CosmosCheckboxGroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosCheckboxGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        /**
         * Sets the Checkbox Group into an invalid state. Additionally, set individual Checkbox child components to invalid.
         */
        this.invalid = false;
        this.computedAppearance = 'dark';
        this.groupInvalid = false;
        this.checkboxes = [];
        this.reannounceValidationMessage = async () => {
            if (this.validationMessageRef) {
                // Reset validation message to trigger re-announcement of the live region by screen readers
                // The aria-label is updated instead of the text content to avoid a visual flash
                this.validationMessageRef.ariaLabel = '';
                await nextTick();
                this.validationMessageRef.ariaLabel = this.getValidationMessage();
            }
        };
        this.handleSlotChange = () => {
            this.initializeCheckboxes();
            forceUpdate(this); // Force re-render to update the help text aria-label if the slot content changes
        };
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
        this.updateCheckboxesAppearance();
    }
    handleDisabledChange() {
        this.updateCheckboxesDisabledState();
    }
    handleInvalidChange(newValue) {
        this.groupInvalid = newValue;
        this.updateCheckboxesInvalidState();
    }
    handleInputInvalid() {
        this.groupInvalid = true;
        this.updateCheckboxesInvalidState();
        this.reannounceValidationMessage();
    }
    handleInputChange() {
        this.isInvalidStateControlled();
    }
    getAvailableCheckboxes() {
        return [...this.element.querySelectorAll(checkboxTag)];
    }
    updateCheckboxesAppearance() {
        this.checkboxes.forEach((checkbox) => {
            checkbox.appearance = this.computedAppearance;
        });
    }
    updateCheckboxesDisabledState() {
        if (typeof this.disabled != 'undefined') {
            this.checkboxes.forEach((checkbox) => {
                checkbox.disabled = this.disabled;
            });
        }
    }
    // Will not update children to valid if invalid state is controlled
    isInvalidStateControlled() {
        if (!this.invalid) {
            this.groupInvalid = false;
            this.updateCheckboxesInvalidState();
        }
    }
    updateCheckboxesInvalidState() {
        this.checkboxes.forEach((checkbox) => {
            checkbox.invalid = this.groupInvalid;
        });
    }
    getValidationMessage() {
        // Return custom validation message when set
        if (this.validationMessage) {
            return this.validationMessage;
        }
        else {
            // Fallback to native validation message in uncontrolled setting
            if (!this.invalid && this.groupInvalid && this.checkboxes.length) {
                const input = this.checkboxes[0].shadowRoot.querySelector('input');
                return input.validationMessage;
            }
        }
    }
    isCheckboxGroupRequired() {
        return this.checkboxes.some((checkbox) => checkbox.required);
    }
    updateCheckboxesRequiredState() {
        const isRequired = this.isCheckboxGroupRequired();
        this.checkboxes.forEach((checkbox) => {
            checkbox.required = isRequired;
        });
    }
    updateCheckboxesRole() {
        this.checkboxes.forEach((checkbox) => {
            checkbox.setAttribute('role', 'listitem');
        });
    }
    initializeCheckboxes() {
        this.checkboxes = this.getAvailableCheckboxes();
        this.updateCheckboxesDisabledState();
        this.updateCheckboxesInvalidState();
        this.updateCheckboxesAppearance();
        this.updateCheckboxesRequiredState();
        this.updateCheckboxesRole();
    }
    componentWillLoad() {
        this.groupInvalid = this.invalid;
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
        slotMutationService.observe(this.element, this.handleSlotChange);
    }
    disconnectedCallback() {
        slotMutationService.unobserve(this.element);
    }
    render() {
        const isRequired = this.isCheckboxGroupRequired();
        return (h(FormField, { key: '1793b656d58c05ae597d9223d529c921cc9abe71', element: this.element, appearance: this.computedAppearance, class: generateClassNames(), helpText: this.helpText, label: this.label, invalid: this.groupInvalid, optionalLabel: this.optionalLabel, requiredLabel: this.requiredLabel, validationMessage: this.getValidationMessage(), validationMessageRef: (el) => (this.validationMessageRef = el), disabled: this.disabled, required: isRequired }, h("fieldset", { key: 'b0701f82c835b16a7aef0139523441d5ac02089f', "aria-invalid": getAriaInvalid(this.groupInvalid), "aria-labelledby": `label ${getAriaDescribedBy(this.groupInvalid)}`, "aria-required": getAriaRequired(isRequired), class: generateClassNames('fieldset') }, h("div", { key: 'a0ef33d9d70bebb1993bedd4d97a899d81d49080', role: "list", class: generateClassNames('list') }, h("slot", { key: '450babf1322cda88c2f5c9788a425957a1e3a5a2' })))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"],
        "disabled": ["handleDisabledChange"],
        "invalid": ["handleInvalidChange"]
    }; }
    static get style() { return cosmosCheckboxGroupCss; }
}, [1, "cosmos-checkbox-group", {
        "appearance": [513],
        "disabled": [516],
        "helpText": [513, "help-text"],
        "invalid": [516],
        "label": [513],
        "optionalLabel": [513, "optional-label"],
        "requiredLabel": [513, "required-label"],
        "validationMessage": [513, "validation-message"],
        "computedAppearance": [32],
        "groupInvalid": [32]
    }, [[0, "inputinvalid", "handleInputInvalid"], [0, "inputchange", "handleInputChange"]], {
        "appearance": ["handleAppearanceChange"],
        "disabled": ["handleDisabledChange"],
        "invalid": ["handleInvalidChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-checkbox-group", "cosmos-icon-warning", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-checkbox-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosCheckboxGroup$1);
            }
            break;
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosCheckboxGroup = CosmosCheckboxGroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosCheckboxGroup, defineCustomElement };
